import { useGetFolderForInvitesQuery } from '../gql/generated/GetFolderForInvites';

export const useIsRestrictedFolder = (
  folderId?: string,
  shouldSkip: boolean = false
) => {
  const variables = folderId ? { id: folderId } : undefined;

  const folder = useGetFolderForInvitesQuery({
    variables,
    skip: !folderId || shouldSkip,
  })?.data?.account?.asset;

  if (!folderId) return false;

  return (
    folder?.__typename === 'FolderAsset' &&
    folder?.name !== 'root' &&
    Boolean(folder?.restricted)
  );
};
